jQuery(document).ready(function($) {

    //Sticky header
    $(window).scroll(function(){
      var sticky = $('header'),
          scroll = $(window).scrollTop();

      if (scroll >= 250) {
        sticky.addClass('fixed');
      }
      else sticky.removeClass('fixed');
    });

    //Cat button clcik
     $('.cat-filter_button').on('click', function() {
         $(this).toggleClass('active');
         $('.category-dropdown_holder').toggle();
     });

    $('.header-account').on('click', function(e) {
        e.stopPropagation();
        $('.header-account_links').toggle();
    });

    $('.header-account_links').on('click', function(e) {
        e.stopPropagation();
    });

    //Body click
    $('body').on('click', function() {
        $('.header-account_links').hide();
    }); 

    //Owl
     $('#main-owl').owlCarousel({
        items: 1,
        nav: true,
        margin: 5,
      });

     $('#products-owl').owlCarousel({
        items: 2,
        nav: true,
        margin: 16,
        responsive:{
            500: {
              items: 2,
              nav: true,
              margin: 16,
          },
          900: {
              items: 4,
              nav: true,
              margin: 24,
          },
        }
      });

     if($('.product-slider').length) {
         $("#product-slider").lightSlider({
            loop:true,
            keyPress:true,
            item: 1,
            cssEasing: 'ease',
            easing: 'linear',
            controls: false,
            vertical: true,
            verticalHeight: 455,
            vThumbWidth: 65,
            thumbItem: 5,
            thumbMargin: 25,
            enableTouch:true,
            enableDrag:true,
            gallery: true,
            responsive : [
            {
                breakpoint:500,
                settings: {
                    loop:true,
                    keyPress:true,
                    item: 1,
                    cssEasing: 'ease',
                    easing: 'linear',
                    controls: true,
                    vertical: true,
                    verticalHeight: 350,
                    enableTouch:true,
                    enableDrag:true,
                    gallery: false,
                  }
            },
            ],
         });
     }

    //Pack counter
    $('.pack-purchase_item').on('click', function() {
        var itemsInPack = $(this).val();
        $('.pack-purchase_item').removeClass('active');
        $(this).addClass('active');
        $('.pack-count_reciever').html(itemsInPack);
        $('.qty-number').attr('value', itemsInPack);
    });

    $('.pack-label').on('click', function() {
        $('.pack-label').removeClass('active');
        $(this).addClass('active');
        var currentSize = $(this).html();
        $('.size-reciever').html(currentSize);
    });

    $('.product-variant').on('click', function(e) {
        e.preventDefault();
        $('.product-variant').removeClass('active');
        $(this).addClass('active');
        var currentColor = $('img', this).attr('alt');
        $('.color-reciever').html(currentColor);
    });

     $('.quantity-less').on('click', function() {
       var qtyVal = $(this).parent().find('.qty-number').val();
       qtyVal--;
        $(this).parent().find('.qty-number').attr('value', qtyVal);
       if(qtyVal <= 0) {
         $(this).addClass('disabled');
          $(this).parent().find('.qty-number').attr('value', 0);
       }
     });

     $('.quantity-more').on('click', function() {
       var qtyVal = $(this).parent().find('.qty-number').val();
       qtyVal++;
       $(this).parent().find('.qty-number').attr('value', qtyVal);
       $(this).parent().find('.quantity-less').removeClass('disabled');
     });
    
    //Tabs
    $(".sign-tab_content").not(":first").hide();
        $(".sign-tabs h6").click( function() {
        $(".sign-tabs h6").removeClass("current").eq($(this).index()).addClass("current");
        $(".sign-tab_content").hide().eq($(this).index()).show();
    }).eq(0).addClass("current");

    $(".subcategory-dropdown_list").not(":first").hide();
        $(".category-dropdown_list li").hover( function() {
        $(".category-dropdown_list li").removeClass("current").eq($(this).index()).addClass("current");
        $(".subcategory-dropdown_list").hide().eq($(this).index()).show();
    }).eq(0).addClass("current");
    

    //Animations on scroll
    $(window).scroll( function(){
        $('.hideme').each( function(i){
            var bottom_of_object = $(this).offset().top - 700 + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();
            if( bottom_of_window > bottom_of_object ){
                $(this).animate({'opacity':'1'}, 1500);
                $('.animate__title', this).addClass('show');
                $('.blind__image', this).removeClass('blind__image');
                $('.translate__block', this).css({
                    'transform': 'translateY(0)',
                    'opacity': '1'
                });
            }
        }); 
    });

    //Mobile button
    $('.hamburger').on('click', function() {
        $(this).toggleClass('active');
        $('body').toggleClass('overflow');
        $('.mobile-menu').toggle();
    });

    $('.mobile-filter_title').on('click', function() {
        $(this).toggleClass('active');
        $('.products-sort').toggle();
        $('.category-sidebar').toggle();
    });

    if(innerWidth <= 500) {
        $('.mobile-menu .menu-item-has-children').on('click', function(e) {
            e.stopPropagation();
            $(this).toggleClass('active');
            $('.sub-menu', this).toggle();
            $('.sub-menu .sub-menu', this).hide();
        });
    }

   //Scroll to
    $("#scroll1").click(function() {
        $('html, body').animate({
            scrollTop: $("#first__to").offset().top
        }, 2000);
    });

    //Date dropdown
    $('.date-dropdown_holder').on('click', function() {
        $('.date-dropdown', this).toggle();
    });

    $('.date-dropdown div').on('click', function() {
        var dateValue = $(this).html();
        $(this).parent().parent().find('input').attr('value', dateValue);
    });

    $('.checkout-row label').on('click', function() {
        $(this).parents('.checkout-rows_holder').find('.checkout-row label').removeClass('active');
        $(this).addClass('active');
        if($(this).hasClass('no-card_payment--choice')) {
            $(this).parents('.checkout-form_wrap').find('.add-newcard_form').hide();
        }
    });

    $('.add-delivery_button').on('click', function(e) {
        e.preventDefault();
        $('.add-new_adress_form').show();
    });

    $('.cancel-adress_button').on('click', function(e) {
        e.preventDefault();
        $('.add-new_adress_form').hide();
    });

    $('.add-card_button').on('click', function(e) {
        e.preventDefault();
        $('.add-newcard_form').show();
    });

    $('.cancel-card_button').on('click', function(e) {
        e.preventDefault();
        $('.add-newcard_form').hide();
    });

    $('.checkbox-label').on('click', function() {
       $(this).toggleClass('active');
       if($(this).hasClass('checkbox-label_associate')) {
           $('.associate-form_part').toggle();
       }
       else if($(this).hasClass('business-toggle')) {
           $('.company-fields').toggle();
       }
     });

    $('.checkout-right_title').on('click', function() {
        $(this).toggleClass('active');
        $('.checkout-products_sidebar').toggle();
    });

    $('.remove-coupon').on('click', function(e) {
        e.preventDefault();
        $(this).parent().hide();
    });

    $('.password-input').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        if($(this).hasClass('active')) {
            $(this).parent().find('input').attr('type', 'text');
        }
        else {
            $(this).parent().find('input').attr('type', 'password');
        }
    });

    $('.forgott-pass_link').on('click', function(e) {
        e.preventDefault();
        $('.account-form-popup').show();
    });

    $('.back-login').on('click', function(e) {
        e.preventDefault();
        $('.account-form-popup').hide();
    });

    $('.account-form_holder input').on('keyup', function() {
        if ($(this).val().length > 0) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          } 
    });


});